import axios from 'axios';
import { get } from 'lodash';
import { URL } from 'config/config';
import { showAlert } from './alert';

export const SET_HOLIDAYS_LOADING = 'SET_HOLIDAYS_LOADING';
export const SET_HOLIDAYS = 'SET_HOLIDAYS';


const setHolidaysLoading = (value = true) => ({
    type: SET_HOLIDAYS_LOADING,
    payload: value
});
const setHolidays = payload => ({
    type: SET_HOLIDAYS,
    payload
});

export const fetchHolidays = () => async dispatch => {
    dispatch(setHolidaysLoading(true));
    try {
        const response = await axios.get(URL.HOLIDAYS);
        if (response && response.data.success) {
            const data = get(response, 'data.objects', []);
            dispatch(setHolidays(data.sort((a, b) => a?.date - b?.date)));
            dispatch(setHolidaysLoading(false));
            return data
        }
    } catch (err) {
        dispatch(setHolidaysLoading(false));
    };
}

export const createHoliday = (payload) => async dispatch => {
    try {
        dispatch(setHolidaysLoading(true));
        const response = await axios.post(URL.HOLIDAYS, payload);
        if (response && response.data.success) {
            const data = get(response, 'data.objects', []);
            dispatch(fetchHolidays());
            dispatch(setHolidaysLoading(false));
            dispatch(showAlert('success', "Holiday added successfuly"))
            return data
        } else if (response?.data?.message) {
            dispatch(showAlert('error', response?.data?.message))
        }
    } catch (err) {
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}

export const editHoliday = (payload) => async dispatch => {
    try {
        const response = await axios.put(URL.HOLIDAYS, payload);
        if (response && response.data.success) {
            const data = get(response, 'data.object', []);
            dispatch(showAlert('success', "Holiday updated successfuly"));
            dispatch(fetchHolidays());
            return data
        } else if (response?.data?.message) {
            dispatch(showAlert('error', response?.data?.message))
        }
    } catch (err) {
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}

export const deleteHoliday = (holidayId) => async dispatch => {
    try {
        const response = await axios.delete(URL.HOLIDAYS + `/${holidayId}`);
        if (response && response.data.success) {
            dispatch(showAlert('success', "Holiday deleted successfuly"));
            dispatch(fetchHolidays());
            return true
        } else if (response?.data?.message) {
            dispatch(showAlert('error', response?.data?.message))
        }
    } catch (err) {
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}